import axios from "axios";
import { sentryAPICatch } from "../sentryAPICatch";

const deleteData = async (url) => {
  try {
    const options = {
      method: "DELETE",
      url: url.charAt(0) === '/' ? "/api" + url : "/api/" + url,
    };
    return (
      await axios(options).catch((err) => {
        if (axios.isCancel(err)) {
          return;
        } else {
          if (err.response.status === 401) {
            let from = window.location.pathname + window.location.search;
            from = from.replaceAll("/logout/expired?from=", "");
            if (from === "/") {
              window.location.href = "/logout/expired";
            } else {
              window.location.href = "/logout/expired?from=" + from;
            }
          } else if (err.request) {
            sentryAPICatch(err, url);
            console.error("Request: ", err);
          } else {
            sentryAPICatch(err, url);
            console.error("Other: ", err);
          }
        }
        return;
      })
    ).data;
  } catch (err) {
    return null;
  }
};
export default deleteData;
